<template>
 <!-- 自定义点框 -->
 <div ref="mapInfoModalRef" class="mapInfoWindow">
  <div v-if="display">
   <div class="arrow" :style="arrowStyle"></div>
   <div class="mapInfoWindowFrame">
    <div class="close" @click="onClose">X</div>
    <div class="title">
     <slot name="title"></slot>
    </div>
    <div class="content" :style="contentStyle">
     <!-- Content Begin -->
     <slot name="content"></slot>
     <!-- Content End -->
    </div>
   </div>
  </div>
 </div>
</template>
<script>

  export default {
    name: 'mapinfomodal',
    components: {},
    props: {},
    data() {
      return {
        mapInfoModalRef:null,
        display: false,
        styleData: {
          width: 230,
          height: 100,
          offset: 30
        },
        contentStyle:{
          height:'50px'
        },
        arrowStyle:{
          top:'120px'
        },
        beforeMapPoint: null,
        beforePoint: null,

        // 地图相关
        _map:null,
        _arcgisModules:null,
      }
    },
    methods: {
      getDisplay(){
        return this.display
      },
      onMapPan(delta){
        if (this.display == true) {
          this.moveModalByDelta(delta.x, delta.y)
        }
      },
      onMapPanEnd(delta){
        if (this.display == true) {
          this.beforePoint.x = this.beforePoint.x + delta.x
          this.beforePoint.y = this.beforePoint.y + delta.y
        }
      },
      onMapZoom(){
        if (this.display == true && this._map) {
          this.mapInfoModalRef.style.display = 'none'
        }
      },
      onMapZoomEnd(){
        if (this.display == true) {
          let zoomPoint = this._map.toScreen(this.beforeMapPoint)
          this.moveModal(zoomPoint.x, zoomPoint.y)
          this.beforePoint = zoomPoint
          this.mapInfoModalRef.style.display = 'block'
        }
      },
      onClose() {
        this._arcgisModules = null
        this._map = null
        this.display = false
        this.mapInfoModalRef.style.display = 'none'
      },
      moveModalByDelta(deltaScreenX, deltaScreenY) {
        this.moveModal(this.beforePoint.x + deltaScreenX, this.beforePoint.y + deltaScreenY)
      },
      moveModal(screenX, screenY) {
        if (!this.display)
          return

        let infowin = this.mapInfoModalRef
        let styleData = this.styleData

        infowin.style.left = (screenX + styleData.offset) + 'px'
        infowin.style.top = (screenY - styleData.height / 2) + 'px'
        infowin.style.position = 'absolute'
        // infowin.style.width = styleData.width + 'px'
        // infowin.style.height = styleData.height + 'px'
        infowin.style.display = 'block'
      },
      moveModalByWebPoint(webPoint){
        if (!this.display)
          return

        this.beforeMapPoint = webPoint
        this.beforePoint = this._map.toScreen(this.beforeMapPoint)

        this.moveModal(this.beforePoint.x, this.beforePoint.y)
      },
      showModalByLatLng(map, arcgisModules, wgs84Lng, wgs84Lat) {
        let aMapPos = GPS.gcj_encrypt(wgs84Lat, wgs84Lng)
        let posChange = new arcgisModules.point(aMapPos.lon, aMapPos.lat, map.spatialReference)
        // 转换成平面投影坐标系
        posChange = arcgisModules.webMercatorUtils.geographicToWebMercator(posChange)

        this.showModal(map, arcgisModules, posChange.x, posChange.y)
      },
      showModal(map, arcgisModules, webX, webY) {

        this._map = map
        this._arcgisModules = arcgisModules

        this.display = true
        this.beforeMapPoint = new arcgisModules.point(webX, webY, map.spatialReference)
        this.beforePoint = map.toScreen(this.beforeMapPoint)

        let infowin = this.mapInfoModalRef
        let styleData = this.styleData

        infowin.style.left = (this.beforePoint.x + styleData.offset) + 'px'
        infowin.style.top = (this.beforePoint.y - styleData.height / 2) + 'px'
        infowin.style.position = 'absolute'
        infowin.style.width = styleData.width + 'px'
        infowin.style.height = styleData.height + 'px'
        this.contentStyle.height = (styleData.height - 10) + 'px'
        this.arrowStyle.top = styleData.height / 2 + 'px'
        infowin.style.display = 'block'

        // let level = map.getLevel()
        // let pres = Math.min(6, level)
        // let v = arcgisModules.webMercatorUtils.xyToLngLat(webX.toFixed(pres), webY.toFixed(pres))
        // let pos = GPS.gcj_decrypt(v[1], v[0])
        // this.content.lng = pos.lon
        // this.content.lat = pos.lat
        // reqReverseGeocoder(pos.lat, pos.lon, (addr) => {
        //   this.content.addr = addr
        // })

      }
    },
    computed: {},
    mounted() {
      this.$nextTick(() => {
        this.mapInfoModalRef = this.$refs.mapInfoModalRef
        console.log('mapInfoModalRef is')
        console.log(this.mapInfoModalRef)
      })
    }
  }

</script>
<style lang="less">

 .mapInfoWindowFrame {
  overflow: hidden;
  border-radius: 5px;
  box-shadow: 0px 0px 3px #888888;
 }

 .mapInfoWindow {
  display: none;
  z-index: 999;
  background-color: transparent;
 }

 .close {
  float: right;
  padding-top: 3px;
  font-weight: bold;
  font-size: 12px;
  color: #FFF;
  height: 30px;
  width: 30px;
  text-align: center;
 }

 .close:hover {
 }

 .title {
  /*border-radius: 4px !important;*/
  background-color: #1097ff;
  padding: 3px;
  font-weight: bold;
  font-size: 10px;
  color: #FFFFFF;
 }

 .content {
  /*border-radius: 4px !important;*/
  padding-left: 5px;
  padding-top: 5px;
  background-color: #FFFFFF;
  color: #000000;
 }

 .arrow {
  position: absolute;
  width: 0px;
  height: 0px;
  line-height: 0px;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-right: 10px solid #FFFFFF;
  left: -10px;
  top: 120px;
 }

</style>
